import { useEffect } from "react";
import { useGetIdentity } from "ra-core";
import {
  appearanceKey,
  appearanceAccount,
  usePersistentAppearance,
  saveAppearance,
} from "@/components/admin/appearance-preferences";

export type AppFont = "inter" | "rovero";
const fonts: readonly AppFont[] = ["inter", "rovero"];

export const useFontPreference = () => {
  const { identity } = useGetIdentity();
  const account = appearanceAccount(identity?.id);
  const key = appearanceKey(account, "font");
  const legacyKey = `RaStoreCRM.appearance.font.${account}`;
  const [font, setFont] = usePersistentAppearance<AppFont>(
    key,
    "inter",
    fonts,
    legacyKey,
  );
  useEffect(() => {
    if (
      !window.localStorage.getItem(key) &&
      window.localStorage.getItem(legacyKey)
    )
      saveAppearance(key, font);
  }, [key, legacyKey, font]);
  return [font, setFont] as const;
};

export const useApplyFontPreference = () => {
  const [font] = useFontPreference();
  useEffect(() => {
    document.documentElement.dataset.appFont =
      font === "rovero" ? "rovero" : "inter";
    return () => {
      document.documentElement.dataset.appFont = "inter";
    };
  }, [font]);
};
